export var LocalStorageKey;
(function (LocalStorageKey) {
    LocalStorageKey["TaskBoardContainer_OpenTaskIdsArray"] = "TaskBoardContainer_OpenTaskIdsArray";
    LocalStorageKey["MyTasksWidgetWhereICanStart"] = "MyTasksWidget_WhereICanStart";
    LocalStorageKey["MyTasksWidgetConfiguredKpis"] = "MyTasksWidget_ConfiguredKpis";
})(LocalStorageKey || (LocalStorageKey = {}));
export var setLocalStorageItem = function (key, value) {
    localStorage.setItem(key.toString(), JSON.stringify(value));
};
export var getLocalStorageItem = function (key, defaultValue) {
    var value = localStorage.getItem(key.toString());
    if (value)
        return JSON.parse(value);
    return defaultValue || undefined;
};
